import styled from 'styled-components';
import { formatNotificationCount } from '../utility/formatNotificationCount';

const SidebarBadge = styled.span`
  background: ${({ theme }) => theme.colors.danger};
  position: absolute;
  top: 10px;
  right: 2px;
  border-radius: 3px;
  font-size: 10px;
  color: ${({ theme }) => theme.colors.white};
  min-width: 16px;
  height: 15px;
  padding: 0 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  box-sizing: border-box;
`;

const InlineBadge = styled.span`
  background: ${({ theme }) => theme.colors.danger};
  border-radius: 3px;
  font-size: 10px;
  color: ${({ theme }) => theme.colors.white};
  min-width: 16px;
  height: 15px;
  padding: 0 4px;
  margin-left: 6px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  box-sizing: border-box;
  vertical-align: middle;
`;

interface NotificationBadgeProps {
  count?: number;
  className?: string;
  /** Sidebar icon anchor (absolute) vs inline next to labels (e.g. tabs). */
  variant?: 'sidebar' | 'inline';
}

/** Red pill with count; hidden when count is 0 or undefined. Shows "99+" when count &gt; 99. */
export function NotificationBadge({
  count,
  className,
  variant = 'sidebar',
}: NotificationBadgeProps) {
  if (count == null || count === 0) {
    return null;
  }

  const label = formatNotificationCount(count);
  if (variant === 'inline') {
    return <InlineBadge className={className}>{label}</InlineBadge>;
  }

  return <SidebarBadge className={className}>{label}</SidebarBadge>;
}
